export default __webpack_public_path__ + "static/media/SFCINEMA_web_main.adfafdb8.png";